<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
  >
    <v-card>
      <v-card-title class="dialog-title d-flex justify-space-between">
        <span>{{ $t('routes.pod.exportFile') }}</span>
        <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="scrollable mt-4 pt-4">
        <p>{{ $t('routes.pod.exportFileDialogText') }}</p>
        <ul class="ml-4 mt-4" v-for="pod in pods" :key="pod.id">
          <li>{{ pod.name }}</li>
        </ul>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="flat" @click="exportThings" elevation="0">{{ $t('common.export') }}
        </v-btn>
        <v-btn @click="dialog = false">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogModel from '@/components/mixin/DialogModel.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import { useAuthStore } from '@/stores/AuthStore.js';
import { useCommonStore } from '@/stores/CommonStore.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "ExportPodDialog",
  props: {
    pods: {
      type: Array,
      required: false
    },
  },
  data() {
    return {};
  },
  methods: {
    async exportThings() {
      const hasPods = (this.pods && this.pods.length > 0);

      const payload = {
        podids: hasPods ? this.pods.map((i) => i.id) : [],
      };

      const authStore = useAuthStore();
      await authStore.getCurrentSession();

      this.dialog = false;

      const commonStore = useCommonStore();
      await commonStore.exportThings(payload);
    },
  },
}
</script>
